module.exports = __webpack_public_path__ + "static/media/perrier.76fc1b4d.jpg";